import React from 'react';
import {BaseScreen} from 'src/design-system';
import {Linking, Text, View} from 'react-native';
import {useStyle} from 'src/providers/style';
import {Typography} from 'src/styles';
import {Separator} from 'src/common-components/atoms';
import Icon from 'react-native-vector-icons/FontAwesome';

const ManagedBillingPromo = () => {
  const styles = useStyle();
  const billingURL =
    'https://calendly.com/d/cn5t-4mq-9s5/raven-health-demo?utm_source=mb_cta';

  return (
    <BaseScreen header={false}>
      <View style={[styles.flex]}>
        <View
          style={[
            styles.paddingVertical,
            styles.paddingHorizontal,
            styles.column,
            styles.alignCenter,
          ]}>
          <Text style={[Typography.H1, styles.paddingMBottom]}>
            Upgrade to Managed Billing -{' '}
          </Text>
          <Text style={[Typography.H2, styles.paddingMBottom]}>
            Stop Leaving Money on the Table.
          </Text>
          <Text>
            <Text style={[Typography.P1_MEDIUM, styles.paddingMBottom]}>
              {'Every month, clinics lose '}
            </Text>
            <Text
              style={[
                styles.underlined,
                Typography.P1_MEDIUM,
                styles.paddingMBottom,
              ]}>
              {'thousands of dollars'}
            </Text>
            <Text style={[Typography.P1_MEDIUM, styles.paddingMBottom]}>
              {' to missed claims and delays.'}
            </Text>
          </Text>
          <Text style={[Typography.P1_MEDIUM]}>
            Our Managed Billing helps you capture more revenue and peace of
            mind.
          </Text>
        </View>
        <View style={[styles.flex, styles.padding, styles.alignCenter]}>
          <View
            style={[
              styles.borderL,
              styles.borderRadius,
              styles.borderColorPrimary300,
              styles.padding,
            ]}>
            <View style={[styles.column, styles.alignCenter]}>
              <View style={[styles.row, styles.alignSelfStart]}>
                <Icon name="check-circle-o" size={40} color={'#050604ff'} />
                <Separator width={20} />
                <Text style={[Typography.P1_BOLD, styles.paddingMTop]}>
                  {'Maximize revenue '}
                </Text>
                <Text style={[Typography.P1_MEDIUM, styles.paddingMTop]}>
                  with nearly 100% reimbursement
                </Text>
              </View>
              <View style={[styles.flex, styles.row, styles.alignSelfStart]}>
                <Icon name="check-circle-o" size={40} color={'#050604ff'} />
                <Separator width={20} />
                <Text style={[Typography.P1_BOLD, styles.paddingMTop]}>
                  {'Simplify Billing '}
                </Text>
                <Text style={[Typography.P1_MEDIUM, styles.paddingMTop]}>
                  we handle claims, errors, and follow-ups
                </Text>
              </View>
              <View style={[styles.flex, styles.row, styles.alignSelfStart]}>
                <Icon name="check-circle-o" size={40} color={'#050604ff'} />
                <Separator width={20} />
                <Text style={[Typography.P1_BOLD, styles.paddingMTop]}>
                  {'Start risk-free - '}
                </Text>
                <Text style={[Typography.P1_MEDIUM, styles.paddingMTop]}>
                  no fees, no out-of-pocket costs
                </Text>
              </View>
            </View>
          </View>
          <View style={[styles.flex, styles.padding, styles.alignCenter]}>
            <Text style={[Typography.P1_MEDIUM, styles.paddingMBottom]}>
              You already trust us with data collection - let us help you
              maximize what you earn.
            </Text>
            <View
              style={[
                styles.row,
                styles.alignCenter,
                styles.borderRadius50,
                styles.paddingLHorizontal,
                styles.paddingLVertical,
                styles.backgroundColorLavender,
              ]}>
              <Text
                onPress={() => Linking.openURL(billingURL)}
                style={[
                  styles.alignSelfCenter,
                  Typography.P1_BOLD,
                  styles.textColorLink,
                ]}>
                Get Started
              </Text>
            </View>
          </View>
        </View>
      </View>
    </BaseScreen>
  );
};

export default ManagedBillingPromo;
